module.exports = __webpack_public_path__ + "img/step04-active.17b9748a.png";